import React from "react";

// Small purse mark that "snaps shut" on send — branded micro-moment for ClearPurse
const Purse = ({ size = 80, snap = false, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={`${className} ${snap ? "purse-snap" : ""}`}
    aria-hidden
  >
    {/* drawstring loops */}
    <path d="M22 16c0-4 4-8 10-8s10 4 10 8" stroke="#0B3B24" strokeWidth="2.5" strokeLinecap="round" className="purse-string" />
    {/* purse body */}
    <path
      d="M14 22c2-3 6-4 18-4s16 1 18 4l4 28c.6 4.2-2.6 8-7 8H17c-4.4 0-7.6-3.8-7-8l4-28Z"
      fill="#0B3B24"
      stroke="#0B3B24"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    {/* purse top flap */}
    <path
      d="M14 22c2-3 6-4 18-4s16 1 18 4"
      stroke="#FBBF24"
      strokeWidth="3"
      strokeLinecap="round"
      className="purse-flap"
    />
    {/* coin/light inside */}
    <circle cx="32" cy="38" r="6" fill="#FBBF24" className="purse-coin" />
  </svg>
);

export default Purse;
